import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';

/**
 * for this page
 */
import Table from '../table';

class Tab extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    state = {
        current: 0,
    };

    handleMouseOver = e => {
        const index = e.currentTarget.getAttribute('index');

        if (index !== this.state.current) {
            this.setState({
                current: index,
            });
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { isOpen } = this.props;
        const { names, tits, data, idx } = this.props.content;
        const { current } = this.state;

        return (
            <div className={styles.tab}>
                <div className={styles.title}>
                    <ul>
                        {names.map((item, index) => (
                            <li
                                key={index}
                                index={index}
                                className={index === current * 1 ? styles.cur : ''}
                                onMouseOver={this.handleMouseOver}>
                                {typeof item === 'string' && item}
                                {typeof item === 'object' && (
                                    <a href={item.url} rel={rel} target="_blank">
                                        {item.name}
                                    </a>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
                {data ? (
                    <Table
                        content={{
                            tit: tits[current],
                            data: data && data[current],
                            idx,
                            _idx: current * 1,
                        }}
                        isOpen={isOpen}
                    />
                ) : (
                    <Table
                        content={{
                            tit: tits[current],
                            data: {},
                            idx,
                            _idx: current * 1,
                        }}
                        isOpen={isOpen}
                    />
                )}
            </div>
        );
    }
}

export default errorBoundary(Tab);
